import React from 'react';
import VelaBriefCard from './VelaBriefCard';
import QuickActions from './QuickActions';
import IncomeChart from './IncomeChart';
import InvoicesProgress from './InvoicesProgress';
import { OVERVIEW_VELA_BRIEFS } from '../data';

// NOTE: The "Sales overview" title + subtitle + "New invoice" button used to
// live as a sticky div at the top of this page. It is now exported as a
// standalone component (SalesOverviewHeader below) and rendered OUTSIDE the
// scrollable main via AppLayout's `pageHeader` prop, so it is permanently
// pinned at the top of the content card with no position: sticky needed.

// Right padding (48px) leaves a visible gap between the content cards and the
// right edge of the content area, so the cards feel contained instead of
// stretching edge-to-edge. Left stays 0 so content keeps hugging the panel.
const MAIN: React.CSSProperties = {
  padding: '0 48px 60px 0',
  background: '#FFFFFF',
};

const MAIN_INNER: React.CSSProperties = {
  maxWidth: '100%',
  margin: 0,
};

const PAGE_HEADER: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  background: '#FFFFFF',
  padding: '14px 32px',
  borderBottom: '1px solid #E7EAF0',
  flexShrink: 0,
};

const H1: React.CSSProperties = {
  fontSize: 20,
  fontWeight: 700,
  margin: 0,
  color: '#0E1A1A',
};

const SUB: React.CSSProperties = {
  fontSize: 12.5,
  color: '#66748B',
  marginTop: 2,
};

const BTN: React.CSSProperties = {
  background: '#0E1A1A',
  color: '#FFFFFF',
  border: 0,
  padding: '8px 14px',
  borderRadius: 8,
  fontSize: 13,
  fontWeight: 600,
  cursor: 'pointer',
};

/**
 * The "Sales overview" page header: title, subtitle, and primary action button.
 * Rendered OUTSIDE the scrollable main by AppLayout via its `pageHeader` prop,
 * so it stays pinned at the top of the content card at all times with no
 * sticky positioning tricks.
 */
export function SalesOverviewHeader(): React.ReactElement {
  return (
    <div style={PAGE_HEADER}>
      <div>
        <h1 style={H1}>Sales overview</h1>
        <div style={SUB}>Everything your business is bringing in.</div>
      </div>
      <button type="button" style={BTN}>New invoice</button>
    </div>
  );
}

export default function SalesOverview() {
  return (
    <div style={MAIN}>
      <div style={MAIN_INNER}>
        {OVERVIEW_VELA_BRIEFS.map((brief) => (
          <VelaBriefCard key={brief.id} brief={brief} />
        ))}

        <QuickActions />
        <IncomeChart />
        <InvoicesProgress />
      </div>
    </div>
  );
}
